module.exports = __webpack_public_path__ + "img/fg4.c637f6a2.jpg";